import { HeartPulse, Sparkles, BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const icons = [HeartPulse, Sparkles, BarChart3];

export const Ecosystem = () => {
  const { t } = useTranslation();

  const pillars = [
    {
      icon: icons[0],
      title: t('ecosystem.pillar1_title'),
      bullets: [t('ecosystem.pillar1_b1'), t('ecosystem.pillar1_b2'), t('ecosystem.pillar1_b3'), t('ecosystem.pillar1_b4')],
    },
    {
      icon: icons[1],
      title: t('ecosystem.pillar2_title'),
      bullets: [t('ecosystem.pillar2_b1'), t('ecosystem.pillar2_b2'), t('ecosystem.pillar2_b3'), t('ecosystem.pillar2_b4')],
    },
    {
      icon: icons[2],
      title: t('ecosystem.pillar3_title'),
      bullets: [t('ecosystem.pillar3_b1'), t('ecosystem.pillar3_b2'), t('ecosystem.pillar3_b3'), t('ecosystem.pillar3_b4')],
    },
  ];

  return (
    <section
      data-testid="verse-ecosystem-section"
      className="py-16 lg:py-24 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg)' }}
    >
      <div className="max-w-[1160px] mx-auto">
        <h2
          className="font-bold tracking-tight text-2xl sm:text-3xl lg:text-[34px] max-w-2xl mx-auto text-center"
          style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
        >
          {t('ecosystem.title')}
        </h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-12">
          {pillars.map((pillar, i) => {
            const Icon = pillar.icon;
            return (
              <div
                key={i}
                className={`rounded-[24px] border p-8 sm:p-10 transition-colors duration-200 ${i === 2 ? 'sm:col-span-2 sm:max-w-[50%] sm:mx-auto lg:col-span-1 lg:max-w-none' : ''}`}
                style={{
                  backgroundColor: 'rgba(255,255,255,0.06)',
                  borderColor: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.28)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)';
                  e.currentTarget.style.borderColor = 'rgba(214,168,74,0.26)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                }}
              >
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center mb-5"
                  style={{
                    backgroundColor: 'rgba(214,168,74,0.12)',
                    border: '1px solid rgba(214,168,74,0.25)',
                  }}
                >
                  <Icon className="w-5 h-5" style={{ color: 'var(--vc-gold)' }} />
                </div>
                <h3
                  className="text-lg sm:text-xl font-semibold tracking-tight"
                  style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-gold)' }}
                >
                  {pillar.title}
                </h3>
                <ul className="mt-5 space-y-2.5">
                  {pillar.bullets.map((bullet, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-3 text-sm leading-relaxed"
                      style={{ color: 'var(--vc-fg-muted)', fontFamily: 'Inter, sans-serif' }}
                    >
                      <span
                        className="mt-2 block w-1.5 h-1.5 rounded-full flex-shrink-0"
                        style={{ backgroundColor: 'var(--vc-gold)' }}
                      />
                      {bullet}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
